import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "../../Styles/Login.css";

const AuthSwitch = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isLogin = location.pathname === "/login";

    const loginRef = useRef(null);
    const registerRef = useRef(null);
    const [pillStyle, setPillStyle] = useState({});

    useEffect(() => {
        const activeBtn = isLogin ? loginRef.current : registerRef.current;
        if (!activeBtn) return;
        setPillStyle({
            left: activeBtn.offsetLeft,
            width: activeBtn.offsetWidth,
        });
    }, [isLogin]);

    return (
        <div className="auth-switch-track" role="tablist">
            <div className="auth-switch-pill" style={pillStyle} />
            <button
                ref={loginRef}
                role="tab"
                aria-selected={isLogin}
                className={`auth-switch-btn ${isLogin ? "active" : "inactive"}`}
                onClick={() => navigate("/login")}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                    <polyline points="10 17 15 12 10 7" />
                    <line x1="15" y1="12" x2="3" y2="12" />
                </svg>
                Connexion
            </button>
            <button
                ref={registerRef}
                role="tab"
                aria-selected={!isLogin}
                className={`auth-switch-btn ${!isLogin ? "active" : "inactive"}`}
                onClick={() => navigate("/register")}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                </svg>
                Inscription
            </button>
        </div>
    );
};

export default AuthSwitch;